module.exports = __webpack_public_path__ + "img/img26.9f4e1923.jpg";